var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-selector"},[_c('Scrolly',{staticClass:"tabs-selector__scrolly"},[_c('ScrollyViewport',{staticClass:"tabs-selector__scrolly-viewport"},[_vm._t("default")],2),_c('ScrollyBar',{attrs:{"axis":"x"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }